// extracted by mini-css-extract-plugin
var _1 = "DraftsView-module__animateUploadProgressBarWidth--C7tAc";
var _2 = "DraftsView-module__animatedBackground--T9voa";
var _3 = "DraftsView-module__container--fTcUg";
var _4 = "DraftsView-module__tab--xk2nT";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "tab" }
